import moment from "moment"
import { useState } from "react"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from '@fullcalendar/daygrid'

import { usePet, useToggle } from "../../modules"

import Receive from "../../components/reusable/receive"

import TypeOfEvent from "../../components/modals/typeofEvent"

const Appointments = ({ category }) => {
    const [events, setEvents] = useState()
    const [event, setEvent] = useState()

    const [evVisible, toggleEvVisible] = useToggle()

    const [{ loading, error, data }] = usePet('scheduledVisits', {
        from: moment().startOf('month'),
        to: moment().endOf('month')
    }, { notify: true, callback: ({ data }) => {
        let final = []
        Object.keys(data)
            .forEach(date => 
                Object.keys(data[date])
                    .forEach(cons => 
                        final.push({
                            title: `${data[date][cons]?.patients?.length} - ${cons}`,
                            date,
                            patients: data[date][cons]?.patients
                        })))
        setEvents(final)
    } })

    const toggleEvent = ev => {
        try {
            let title = ev?.event?._def?.title
            // console.log({title})
            let evnt = events.find(evt => evt.title === title)
            // console.log(evnt)
            evnt.title = title.split(' - ')[1]
            setEvent(evnt)
            toggleEvVisible()
        } catch (error) {
            console.log(error)
        }
    }
    
    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <TypeOfEvent
                toggle={ toggleEvVisible }
                visible={ evVisible }
                event={ event } />
            <Receive
                progress
                loading={loading}
                error={error}>
                <FullCalendar
                    initialView="dayGridMonth"
                    events={events}
                    eventClick={ toggleEvent }
                    plugins={[dayGridPlugin]}
                    editable={true}
                    selectable={true}
                    selectMirror={true}
                    dayMaxEvents={true} />
            </Receive>

        </div>
    )
}

export default Appointments